import { IClientConfigs, IVehiclePaint } from '~/shared';
import { createSlice } from '../wrappers';

interface CarPaintSlice {
	activePaintGroup: IClientConfigs['vehiclesPaint']['types'][number] | null;
	ownedVehiclePaint: IVehiclePaint | null;
}

const initialState: CarPaintSlice = {
	activePaintGroup: null,
	ownedVehiclePaint: null,
};

const carPaintSlice = createSlice({
	name: 'carPaint',
	initialState,
	reducers: {
		setActivePaintGroup: (state, action) => {
			state.activePaintGroup = action.payload;
		},
		setOwnedVehiclePaint: (state, action) => {
			state.ownedVehiclePaint = action.payload;
		},
	},
});

export const { setActivePaintGroup, setOwnedVehiclePaint } =
	carPaintSlice.actions;

export default carPaintSlice.reducer;
